// extracted by mini-css-extract-plugin
module.exports = {"storeDetailsContainer":"P70FindStores_storeDetailsContainer__5nDgv","storeDetailsContent":"P70FindStores_storeDetailsContent__Yv_LE"};